module.exports = __webpack_public_path__ + "resources/avatar_placehold.40febd0716207eb1.png";